/** CoStar.Api.ConsumerUserData.CheckAvailability.MoveInDateType */
export var MoveInDateType;
(function (MoveInDateType) {
    MoveInDateType[MoveInDateType["Unknown"] = 0] = "Unknown";
    MoveInDateType[MoveInDateType["MoveInNow"] = 1] = "MoveInNow";
    MoveInDateType[MoveInDateType["MoveInThisMonth"] = 2] = "MoveInThisMonth";
    MoveInDateType[MoveInDateType["MoveInNextMonth"] = 3] = "MoveInNextMonth";
    MoveInDateType[MoveInDateType["MovingSoon"] = 4] = "MovingSoon";
})(MoveInDateType || (MoveInDateType = {}));
